import { render, staticRenderFns } from "./MaterialTextarea.vue.js?vue&type=template&id=7862892e!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialTextarea.vue?vue&type=template&id=7862892e"
import script from "./MaterialTextarea.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialTextarea.vue?vue&type=script&lang=js"
export * from "./MaterialTextarea.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports